// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';

import NoticeModal from '../../../DesignSystem/NoticeModal/NoticeModal';
import { useStepHook } from '../logic/useStepHook';
import { WizardFlowActionType } from '../logic/WizardContext';
import { ReactComponent as OopsIcon } from '../../../assets/icons/svg/shared/ic-shared-oops.svg';

export interface ChangePhoneProps {
  onClose: () => void;
}
export const ErrorView = ({ onClose }: ChangePhoneProps) => {
  const { dispatch, t, data } = useStepHook();
  const { error } = data;
  if (!error || !error.errorKey) return <> Something Went Wrong </>;
  const { errorKey } = error;
  const title = t(`CHANGE_PHONE.ERRORS.${errorKey}.title`);
  const description = t(`CHANGE_PHONE.ERRORS.${errorKey}.description`);
  const button1Text = t('CHANGE_PHONE.ERRORS.button1Text');
  const button2Text = t('CHANGE_PHONE.ERRORS.button2Text');

  // const isTwoButtons = button2Text !== 'undefined' && button2Text !== '';
  const handleRetry = () => {
    dispatch({ type: WizardFlowActionType.SET_STEP, payload: 0 });
  };

  const content = (
    <div className='flex  justify-center items-center mb-[48px] gap-1'>
      <p className='text-bw08 text-[14px] font-metricR ' id='description'>
        {description}
        {'  '}
      </p>
      {description.includes('contact us') && (
        <a
          className='font-metricR text-[14px] text-action03 hover:underline  text-center'
          href='mailto:support@lili.co'
          target='_blank'
          rel='noreferrer'
        >
          support@lili.co
        </a>
      )}
    </div>
  );
  return (
    <NoticeModal
      secondaryButtonText={button1Text}
      buttonText={button2Text}
      SvgComponent={OopsIcon}
      title={title}
      id='id'
      content={content}
      onSubmit={handleRetry}
      onClickOutside={onClose}
      shouldPersist
    />
  );
};
